import React, { Component, Fragment } from "react";
import { withStyles } from "@material-ui/styles";

const styles = (theme) => ({
  activeTextField: {
    backgroundColor: "rgba(255, 255, 255, .75)",
  },
  maxLenthStyle: {
    width: "256px",
  },
});

class SingleInput extends Component {
  constructor() {
    super();
    this.state = {
      maxLengthNum: "1000",
      name: "Number",
    };
  }
  // handleChangeNumber = (name) => (event) => {
  //   setData({ ...data, [name]: event.target.data });
  // };
  render() {
    return (
      <Fragment>
        {/* <Box display="flex" pt={1} pb={1} pl={1} pr={1} flexDirection="row">
          <Grid container spacing={3}>
            <Box display="flex" flex={11.0}>
              <Grid item style={{ width: "97%" }}>
                <TextField
                  id="question_text"
                  fullWidth
                  required
                  type="number"
                  label="Answer Label"
                  variant="outlined"
                  onInput={(e) => {
                    e.target.value = Math.max(0, parseInt(e.target.value))
                      .toString()
                      .slice(0, 16);
                  }}
                  className={classes.activeTextField}
                />
              </Grid>
            </Box>
            <Box display="flex" justifyContent="flex-end" flex={0.3} style={{ width: 252 }}>
              <Grid item style={{ width: 252 }}>
                <TextField
                  id="max-length"
                  value={this.state.maxLengthNum}
                  label="Max Length"
                  variant="outlined"
                  color="white"
                  className={classes.activeTextField}
                  className={classes.maxLenthStyle}
                />
              </Grid>
            </Box>
          </Grid>
        </Box> */}
      </Fragment>
    );
  }
}

export default withStyles(styles)(SingleInput);
